import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import GenresTab from "./genres";
import KeywordsTab from "./keywords";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";

function BooksCatalog() {
  const [activeTab, setActiveTab] = useState<number>(0);

  useBreadcrumbs({
    title: "Genres & Keywords",
    path: routeConstant.booksCatalog.path,
  });

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <div>
      {/* Tab Navigation - Following banner/index.tsx pattern */}
      <Box sx={{ borderBottom: 1, borderColor: "divider", marginBottom: 3 }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Genres" />
          <Tab label="Keywords" />
        </Tabs>
      </Box>

      {/* Tab Content */}
      {activeTab === 0 ? <GenresTab /> : <KeywordsTab />}
    </div>
  );
}

export default BooksCatalog;
